import React from "react";

const loadStorage = (key, defaultValue) => {
  if (typeof window === "undefined") return defaultValue;

  try {
    const item = localStorage.getItem(key);
    if (item == null) return defaultValue;
    return JSON.parse(localStorage.getItem(key));
  } catch (err) {
    return defaultValue;
  }
};

export default function useLocalStorage(key, initialValue) {
  const [defaultValue] = React.useState(initialValue);

  const [value, setValue] = React.useState(() =>
    loadStorage(key, defaultValue)
  );

  const setStorageValue = React.useCallback(
    (update) => {
      setValue((current) => {
        const newValue = update instanceof Function ? update(current) : update;

        localStorage.setItem(key, JSON.stringify(newValue));
        window.dispatchEvent(new Event(`localStorageUpdate::${key}`));

        return newValue;
      });
    },
    [key]
  );

  React.useEffect(() => {
    const listener = (e) => setValue(loadStorage(key, defaultValue));

    window.addEventListener("storage", listener);
    window.addEventListener(`localStorageUpdate::${key}`, listener);

    return () => {
      window.removeEventListener("storage", listener);
      window.removeEventListener(`localStorageUpdate::${key}`, listener);
    };
  }, [key, defaultValue]);

  return [value, setStorageValue];
}
